import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { api } from "@/lib/api";
import { useMarket } from "@/lib/market";
import { inr, label, AREA_LABEL, VERIF_LABEL } from "@/lib/fmt";
import { Loading, Empty } from "@/components/Bits";

const ROWS = [
  ["Asking price", (l) => inr(l.data.asking_price)], ["Revenue", (l) => inr(l.fin.revenue)], ["Profit", (l) => inr(l.fin.profit)],
  ["Profit definition", (l) => label(l.fin.profit_definition)], ["Figure type", (l) => label(l.fin.figure_type)],
  ["Margin", (l) => (l.fin.margin_pct != null ? `${l.fin.margin_pct}%` : "Not provided")], ["Monthly rent", (l) => inr(l.data.monthly_rent)],
  ["Employees", (l) => l.data.employees ?? "Not provided"], ["Business age", (l) => (l.data.years_operating != null ? `${l.data.years_operating} years` : "Not provided")],
  ["Owner involvement", (l) => l.data.owner_involvement || "Not provided"], ["Lease status", (l) => label(l.data.lease_transfer_status)],
  ["Sale type", (l) => label(l.data.sale_type)], ["City", (l) => l.data.city],
  ...Object.entries(AREA_LABEL).map(([a, t]) => [`Verification: ${t}`, (l) => VERIF_LABEL[l.verification?.[a]?.status] || "Seller provided"]),
];

export default function Compare() {
  const { compare, setCompare } = useMarket();
  const [items, setItems] = useState(null);
  useEffect(() => { if (!compare.length) { setItems([]); return; } api.get("/public/compare", { params: { ids: compare.join(",") } }).then((r) => setItems(r.data)).catch(() => setItems([])); }, [compare]);
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
      <p className="eyebrow">Side by side</p><h1 className="text-3xl sm:text-4xl text-[#29483D] mt-1 mb-6">Compare businesses</h1>
      {items === null ? <Loading /> : items.length === 0 ? <Empty title="Nothing to compare yet" body="Add up to three businesses using the Compare button on listing cards." action={<Link to="/browse" className="btn-primary">Browse businesses</Link>} testid="compare-empty" /> : (
        <div className="card overflow-x-auto" data-testid="compare-table">
          <table className="tbl min-w-[640px]">
            <thead><tr><th className="w-48">&nbsp;</th>{items.map((l) => (
              <th key={l.id} className="normal-case tracking-normal"><div className="flex justify-between gap-2"><Link to={`/business/${l.slug}`} className="font-display text-base text-[#29483D]">{l.data.title}</Link>
                <button onClick={() => setCompare(compare.filter((x) => x !== l.id))} aria-label="Remove from compare" data-testid={`compare-remove-${l.id}`}><X size={14} /></button></div>
                {l.is_demo && <span className="chip bg-[#49392F] text-white mt-1">Demo listing — not available for purchase</span>}</th>
            ))}</tr></thead>
            <tbody>{ROWS.map(([k, fn]) => <tr key={k}><td className="font-semibold text-[#49392F] text-xs">{k}</td>{items.map((l) => <td key={l.id}>{fn(l)}</td>)}</tr>)}</tbody>
          </table>
        </div>
      )}
    </div>
  );
}
